export default __webpack_public_path__ + "static/media/279.d7e97062.gif";